import { elementOpen, elementVoid, elementClose, patch } from 'incremental-dom';
import { BehaviorSubject } from 'rxjs';
import { first, map, takeWhile } from 'rxjs/operators';
var CommitInfo = require('virtual/commitinfo.js');
var fullPixList = [];
var pixLoadedObservable = new BehaviorSubject(fullPixList);
var sitePix = function (assetBase, id, optional) {
    if (typeof optional === 'string') {
        console.log('Deprecation Warning: mediasizes passed as string to sitePix');
    }
    var pixOptions = (typeof optional === 'string')
        ? { mediaSizes: optional }
        : optional || {};
    pixOptions.class = "sitepix-" + id.replace('/', '-') + (pixOptions.class ? ' ' + pixOptions.class : '');
    var portfolioPixContent = function (thisPix) {
        var defaultSize = thisPix.sizes.sort(function (a, b) { return (Math.pow((a - 400), 2) < Math.pow((b - 400), 2)) ? -1 : +1; })[0]; // With the size closest to 400
        var file = thisPix.file, hash = thisPix.hash, sizes = thisPix.sizes, pathprefix = thisPix.pathprefix, format = thisPix.format;
        if (pixOptions.minimum) {
            elementVoid('source', 'banner-blank-src', ['type', 'image/gif', 'srcset', 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==', 'media', "(max-width: " + (pixOptions.minimum - 1) + "px)"]);
        }
        if (format === 'jpg') {
            var webpSrc = sizes.map(function (s) { return "" + assetBase + pathprefix + "/" + file + "-" + hash + "-" + s + ".webp " + s + "w"; }).join();
            var jpgSrc = sizes.map(function (s) { return "" + assetBase + pathprefix + "/" + file + "-" + hash + "-" + s + ".jpg " + s + "w"; }).join();
            [['image/webp', webpSrc], ['image/jpeg', jpgSrc]].map(function (_a) {
                var type = _a[0], src = _a[1];
                elementVoid('source', "source-" + type.replace('/', '-'), ['type', type, 'srcset', src, 'sizes',
                    pixOptions.mediaSizes || '(max-width: 499px) 50vw, ((min-width: 500px) and (max-width: 768px)) 33vw, 25vw']);
            });
            elementVoid('img', null, ['src', "" + assetBase + pathprefix + "/" + file + "-" + hash + "-" + defaultSize + ".jpg"]);
        }
        else {
            var pngSrc = sizes.map(function (s) { return "" + assetBase + pathprefix + "/" + file + "-" + hash + "-" + s + ".png " + s + "w"; }).join();
            [['image/png', pngSrc]].map(function (_a) {
                var type = _a[0], src = _a[1];
                elementVoid('source', "source-" + type.replace('/', '-'), ['type', type, 'srcset', src, 'sizes',
                    pixOptions.mediaSizes || '(max-width: 499px) 50vw, ((min-width: 500px) and (max-width: 768px)) 33vw, 25vw']);
            });
            elementVoid('img', null, ['src', "" + assetBase + pathprefix + "/" + file + "-" + hash + "-" + defaultSize + ".png"]);
        }
    };
    var el2;
    if (pixOptions.placeholder) {
        elementOpen('div', "sitepix-wrapper-" + id.replace('/', '-'), ['class', "sitepix-wrapper sitepix-wrapper-" + id.replace('/', '-')]);
        elementVoid('img', 'placeholder', ['class', 'placeholder-svg', 'type', 'image/svg', 'src', "data:image/svg+xml;charset=UTF-8," + pixOptions.placeholder]);
        el2 = elementVoid('picture', null, ['class', pixOptions.class]);
        if (pixOptions.filter) {
            elementVoid('div', "sitepix-filter-" + id.replace('/', '-'), ['class', "sitepix-filter sitepix-filter-" + id.replace('/', '-')]);
        }
        elementClose('div');
    }
    else {
        elementOpen('div', "sitepix-wrapper-" + id.replace('/', '-'), ['class', "sitepix-wrapper sitepix-wrapper-" + id.replace('/', '-')]);
        el2 = elementVoid('picture', null, ['class', pixOptions.class]);
        if (pixOptions.filter) {
            elementVoid('div', "sitepix-filter-" + id.replace('/', '-'), ['class', "sitepix-filter sitepix-filter-" + id.replace('/', '-')]);
        }
        elementClose('div');
    }
    // Replace the image once the pixlist is available
    pixLoadedObservable
        .pipe(first(function (pl) { return pl.length > 0; }), // Wait until pixlist is loaded
    map(function (pl) { return pl.filter(function (p) { return p.file === id; }); }), // Filter for the chosen image
    takeWhile(function (pl) {
        if (pl.length === 0) {
            console.log("**** Image " + id + " not found in pixlist");
            return false;
        }
        return true;
    }), map(function (pl) { return pl[0]; }))
        .subscribe(function (pix) {
        // NICE: Fade in image if placeholder is already shown.
        // setTimeout( _ => {
        patch(el2, function () { return portfolioPixContent(pix); });
        // }, 3000);
    });
    return el2;
};
var getStorePix = function (assetBase, fullpixlist) {
    var httpGet = function (url) { return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.withCredentials = true;
        // If any headers are set CORS makes an OPTIONS request.  We do not need CORS for fullpixlist.json so we will bypass this
        // xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        // xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.withCredentials = false;
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200 || (xhr.status === 0 && xhr.responseText !== '')) {
                    // setTimeout(() => {
                    resolve({
                        url: url,
                        status: 200,
                        body: xhr.responseText || ''
                    });
                    // }, 30000)
                }
                else {
                    resolve({
                        url: url,
                        status: xhr.status,
                        body: xhr.responseText || ''
                    });
                }
            }
        };
        xhr.send();
    }); };
    httpGet("" + assetBase + fullpixlist + "?buildid=" + CommitInfo.commit)
        .then(function (response) {
        if (response.status === 200) {
            fullPixList = JSON.parse(response.body); // Error Catch
            pixLoadedObservable.next(fullPixList);
        }
        else {
            // Error Catch
        }
    });
};
// Preload pixlist
// setTimeout(() => getStorePix(), 2000);
// getStorePix()
export { sitePix, pixLoadedObservable, getStorePix };
//# sourceMappingURL=pixList.js.map